import toPercentString from './toPercentString';
import type { LayoutPositionDetails } from '../interfaces/LayoutPositionDetails';

export default function convertLayoutPositionToFlexStyles(
    layoutPosition: LayoutPositionDetails
): React.CSSProperties {
    return {
        flexBasis: toPercentString(1 - layoutPosition.right - layoutPosition.left),
    };
}
